"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutConfigs = void 0;
exports.layoutConfigs = {
    LINE_HEIGHT: {
        loose: '21px',
        tight: '12px'
    },
    FONT_SIZE: {
        large: '2rem',
        medium: '1.8rem',
        small: '1.6rem' // 16px
    },
    LABEL_WIDTH: {
        large: '140px',
        medium: '120px',
        small: '90px'
    },
    SIDEBAR_WIDTH: {
        shrink: '60px',
        expand: '318px'
    }
};
